/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Select_AllInputs */

const en_input_select_all = /** @type {(inputs: Input_Select_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select All`)
};

/**
* | output |
* | --- |
* | "Select All" |
*
* @param {Input_Select_AllInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const input_select_all = /** @type {((inputs?: Input_Select_AllInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Select_AllInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_input_select_all(inputs)
});